export default __webpack_public_path__ + "static/media/info_cashout.min.6b3c005c.png";